import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
// import { useTimeZone } from '../../../hooks/useTimeZone';
import { Button, SelectDropDown } from '@wot/components';
import { updateUser } from '../../../reducers/userSlice';
import { getCurrencyFromCode } from '../../../utils/getVisitorInfo';
import Currencies from './currencies.json';

export default function Settings() {
  const [loading, setLoading] = useState(false);
  // const ctz = useTimeZone();
  const { currency: c /* , timezone: t */ } = useAppSelector((state) => state.visitorInfoSlice);
  // @ts-ignore
  const timezones = Intl.supportedValuesOf('timeZone');
  // @ts-ignore
  let currencies = Object.keys(Currencies).map(
    //@ts-ignore
    (item) => `${item}(${Currencies[item].name_plural})`
  );
  const { userData } = useAppSelector((state) => state.userSlice);
  const [lessonUpdates, setLessonUpdates] = useState(userData?.preference?.lessonUpdates || false);
  const [accountUpdates, setAccountUpdates] = useState(userData?.preference?.accountUpdates || false);
  const [currency, setCurrency] = useState(
    userData?.preference?.currency || {
      code: c.code,
      name: c.name,
      symbol: c.symbol
    }
  );
  const [timezone, setTimezone] = useState(
    userData?.preference?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  const dispatch = useAppDispatch();

  const onSave = async () => {
    setLoading(true);
    await dispatch(
      updateUser({
        preference: {
          lessonUpdates,
          accountUpdates,
          currency,
          timezone
        }
      })
    )
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };
  return (
    <div className="w-full h-full flex flex-col gap-5">
      <div className="w-full flex flex-col gap-4 p-7 border border-neutralGray3 rounded-sm mt-5">
        <h1 className="text-lg font-semibold mb-2">Email Notifications</h1>

        <div className="w-full flex items-center">
          <p className="w-2/5 md:w-1/5 text-sm whitespace-nowrap">Lesson Updates</p>
          <Toggle value={lessonUpdates} handleChange={(value) => setLessonUpdates(value)} />
        </div>

        <div className="w-full flex items-center">
          <p className="w-2/5 md:w-1/5 text-sm whitespace-nowrap">Account Updates</p>
          <Toggle value={accountUpdates} handleChange={(value) => setAccountUpdates(value)} />
        </div>
      </div>

      <div className="w-full flex flex-col gap-4 p-7 border border-neutralGray3 rounded-sm">
        <h1 className="text-lg font-semibold mb-2">Currency Settings</h1>
        <div className="w-full flex items-center gap-10">
          <p className="text-sm">Choose Currency</p>
          <div className="w-full max-w-[250px]">
            <SelectDropDown
              placeholder="Choose Currency"
              options={currencies}
              value={`${currency.code}(${currency.name})`}
              onChange={(value) => {
                let code = value.slice(0, 3);
                let x = getCurrencyFromCode(code);
                setCurrency(x);
              }}
              isSearchable
            />
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col gap-4 p-7 border border-neutralGray3 rounded-sm">
        <h1 className="text-lg font-semibold mb-2">Timezone</h1>
        <div className="w-full flex items-center gap-10">
          <p className="text-sm">Choose Timezone</p>
          <div className="w-full max-w-[250px]">
            <SelectDropDown
              placeholder="Timezone"
              options={timezones}
              value={timezone}
              onChange={(value) => setTimezone(value)}
              isSearchable
            />
          </div>
        </div>
      </div>

      {/* <span className="text-base font-medium text-primary cursor-pointer">Deactivate my account</span> */}

      <div className="w-full h-full flex items-center justify-center mt-auto">
        <div className="w-full max-w-[164px]">
          <Button loading={loading} block onClick={onSave} text="Save" />
        </div>
      </div>
    </div>
  );
}

function Toggle({ value, handleChange }: { value: boolean; handleChange: (value: boolean) => void }) {
  const [toggle, setToggle] = useState(value);
  useEffect(() => {
    handleChange(toggle);
  }, [toggle]);
  return (
    <div
      onClick={() => setToggle(!toggle)}
      className={`relative w-12 h-6 rounded-full ${
        toggle ? 'bg-primary' : 'bg-gray-100'
      } transition-all duration-500 cursor-pointer p-1`}
    >
      <div
        className={`absolute top-[2px] ${
          toggle ? 'left-[55%]' : 'left-[2px]'
        } transition-all duration-500 w-5 h-5  rounded-full bg-white`}
      ></div>
    </div>
  );
}
